import React, { useEffect, useRef } from 'react';
import './css/index.scss';
import { useAtomValue, useSetAtom, useAtom } from 'jotai';
import { useLocation } from 'react-router-dom';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import Sidebar from '../SideBar';
import {
  containerRefCurrentAtom, isNavBarExpandedAtom, windowHeightAtom, zoomOutRatioAtom,
} from '../../atoms/globalAtoms';
import MyModal from '../MyModal';
import useWindowSize from '../../hooks/UseWindowResize';
import Header from '../Header';
import Footer from '../Footer';

const MANIFEST_URL = 'https://fragment-online.com/ton-connect/tonconnect-manifest.json';

function Wrapper({ children }) {
  const location = useLocation();
  const shouldWrap = !location.pathname.startsWith('/transaction/pay.cryptomus.com');

  return (
    shouldWrap ? (
      <div className="wrapper">
        {/* <TonConnectUIProvider manifestUrl={MANIFEST_URL}> */}
        <Header />
        <div id="container" className="container">
          <div className="container_inner">
            {children}
          </div>

          <Footer />
        </div>
        <MyModal />
        {/* </TonConnectUIProvider> */}
      </div>
    ) : (
      children
    )

  );
}

export default Wrapper;
